<template>
  <div>
    <div :id="'w'+hash"></div>
  </div>
</template>

<script>
export default {
  name: "Webloyalty",
  props: {
    hash: String,
    ckw: String
  },
  methods:{
    encode(v) {
      var hex = "";
      for (var i = 0; i < v.length; i++) {
        hex += "" + v.charCodeAt(i).toString(16);
        }
      return hex;
    }
  },
  mounted(){
    window.prodID.a.push({ "h": this.encode(this.hash), "ckw":this.ckw, "r": false })
  }
}
</script>